import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    bankStatement: 'Bank statement · {0}',
    feeStatementTitle: 'Fee statement · Year {0}',
    noStatements:
      'Your first statement will be available at the beginning of next month.',
    noStatementsForAccount:
      "You don't have any statement for this bank account yet.\nYour first statement will be available at the beginning of next month.",
    title: 'Account statements',
  },
  fr: {
    bankStatement: 'Relevé bancaire · {0}',
    feeStatementTitle: 'Relevé de frais annuel · Année {0}',
    noStatements:
      'Votre premier relevé sera disponible au début du prochain mois.',
    noStatementsForAccount:
      'Vous n’avez pas encore de relevé pour ce compte.\nVotre premier relevé sera disponible au début du prochain mois.',
    title: 'Relevés de compte',
  },
} as const);

export default locales;
